import { eff } from "@/core/utils/effect-ts-abbr";
import { formatNumber } from "@/core/utils/format-number";
import { RangeFilterItemDto } from "@/shared/api-contract/api-contract";
import { InputHTMLAttributes, watchEffect } from "vue";
import { Emit, Model, Prop, Vue } from "vue-property-decorator";
import { AppRangeSliderModel } from "../app-range-slider/app-range-slider-model";
import "./app-dropdown-range.scss";

export class AppDropdownRangeComponent extends Vue {
    @Prop()
    placeholder?: string;

    @Prop({ required: true, type: Array })
    items!: RangeFilterItemDto[];

    @Model("modelValue")
    model!: AppRangeSliderModel;

    @Prop({ default: -Infinity })
    minPossibleValue!: number;

    @Prop({ default: Infinity })
    maxPossibleValue!: number;

    @Prop({ default: (it: string) => parseFloat(it), type: Function })
    fromString!: (value: string) => number;

    @Prop({ default: eff.ord.number, type: Object })
    ord!: eff.ord.Ord<number>;

    @Prop({ type: Object })
    minAttrs!: InputHTMLAttributes;

    @Prop({ type: Object })
    maxAttrs!: InputHTMLAttributes;

    @Prop()
    unit?: string;

    /**
     * Block dropdown when no options provided.
     */
    @Prop({ default: true, type: Boolean })
    blockEmpty!: boolean;

    /**
     * Block dropdown when single item provided in the options.
     */
    @Prop({ default: false, type: Boolean })
    blockSingle!: boolean;

    isOpen = false;

    get canShowPlaceholder() {
        return (
            !!this.placeholder &&
            this.items.length > 0 &&
            this.from === this.items[0].min_value &&
            this.to === this.items[this.items.length - 1].max_value
        );
    }

    get from(): number {
        return this.model.from === null || this.items.length > 0
            ? this.items[0].min_value
            : this.model.from;
    }

    get to(): number {
        return this.model.to === null || this.items.length > 0
            ? this.items[this.items.length - 1].max_value
            : this.model.to;
    }

    get formattedFrom(): string {
        return formatNumber()(this.from as number);
    }

    get formattedTo(): string {
        return formatNumber()(this.to as number);
    }

    get blocked() {
        return (
            (!this.items.length && this.blockEmpty) ||
            (this.items.length <= 1 && this.blockSingle)
        );
    }

    @Emit("blocked")
    emitBlocked() {
        return this.blocked;
    }

    mounted() {
        watchEffect(() => {
            this.emitBlocked();
        });
    }
}
